import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Optional, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from './services/auth.service';
import { IdleService } from './services/business/impl/idleService';
import { isPublicSsrRoute } from './ssr/public-ssr.routes';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
})
export class AppComponent {
  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private router: Router,
    @Optional() private idleService: IdleService | null,
    @Optional() private authService: AuthService | null,
  ) {
    if (
      !isPlatformBrowser(this.platformId) ||
      !this.idleService ||
      !this.authService
    ) {
      return;
    }

    const browserIdleService: IdleService = this.idleService;
    const browserAuthService: AuthService = this.authService;

    browserIdleService.setLogoutCallback(() =>
      browserAuthService.signOutUser(),
    );
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const publicRoutes = [
          '/landing',
          '/fira-breakdown',
          '/faq',
          '/contact-us',
          '/privacy-policy',
          '/kyc-onboarding',
          '/authentication',
        ];

        let normalizedUrl = event.url.split('?')[0];
        if (normalizedUrl !== '/' && normalizedUrl.endsWith('/')) {
          normalizedUrl = normalizedUrl.slice(0, -1);
        }

        if (
          normalizedUrl === '/' ||
          normalizedUrl === '' ||
          isPublicSsrRoute(normalizedUrl)
        ) {
          browserIdleService.stopWatching();
          return;
        }

        const isPublic = publicRoutes.some(
          (route) =>
            normalizedUrl === route || normalizedUrl.startsWith(route + '/'),
        );

        if (!isPublic) {
          browserIdleService.startWatching();
        } else {
          browserIdleService.stopWatching();
        }
      });
  }
  title = 'RemitCircle';
}
